import React from 'react';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="gradient-text">RiftCo</h3>
            <p>Transforming businesses with next-generation SaaS solutions</p>
          </div>
          
          <div className="footer-links">
            <div className="link-group">
              <h4>Services</h4>
              <a href="#services">SaaS Solutions</a>
              <a href="#services">Cloud Native</a>
              <a href="#services">DevOps</a>
              <a href="#services">GPU Computing</a>
            </div>
            
            <div className="link-group">
              <h4>Company</h4>
              <a href="#contact">Contact</a>
              <a href="#careers">Careers</a>
              <a href="#blog">Blog</a>
            </div>
            
            <div className="link-group">
              <h4>Resources</h4>
              <a href="#docs">Documentation</a>
              <a href="#support">Support</a>
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
            </div>
          </div>
          
          <div className="footer-social">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="#" aria-label="GitHub"><Github size={20} /></a>
              <a href="#" aria-label="Twitter"><Twitter size={20} /></a>
              <a href="#" aria-label="LinkedIn"><Linkedin size={20} /></a>
              <a href="#" aria-label="Email"><Mail size={20} /></a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} RiftCo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
